import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideCopropriete } from '../../../../config/aides-coproprietes';

export default function EcoPtzCollectifPage() {
  const aide = getAideCopropriete('eco-ptz-collectif');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="coproprietes" />;
}
